/**
 * handlers/conversations.ts
 * Load, display, and delete conversations.
 */

import { state, STORAGE_KEY } from '../state';
import { dom } from '../dom';
import {
  getConversations, getConversation,
  deleteConversation as apiDeleteConversation,
} from '../api';
import {
  appendMessage, showWelcome, renderConversationList, showToast,
} from '../ui-renderers';
import { showChat, newConversation } from './views';

export function loadConversationList() {
  const list = dom.convList;
  if (!list) return;
  list.innerHTML = '<div class="ai-conv-loading">Loading conversations&hellip;</div>';
  getConversations()
    .then(data => {
      state.convCache = data.conversations || [];
      renderConversationList(state.convCache);
    })
    .catch(() => {
      if (list) list.innerHTML =
        '<div class="ai-conv-empty">Could not load conversations.<br>Check your connection.</div>';
    });
}

export function loadConversation(convId: string) {
  state.conversationId = convId;
  sessionStorage.setItem(STORAGE_KEY, convId);
  const msgs = dom.msgs;
  if (msgs) { msgs.innerHTML = ''; state.msgCount = 0; }
  showChat();
  getConversation(convId)
    .then(data => {
      const all = (data.messages || []).concat(data.kvHistory || []);
      all.forEach(turn => appendMessage(turn.role, turn.content, turn.id || ''));
      if (all.length === 0) showWelcome();
    })
    .catch(() => {
      appendMessage('bot', 'Could not load conversation. Please try again.');
    });
}

export function deleteConversation(convId: string) {
  apiDeleteConversation(convId)
    .then(() => {
      if (state.conversationId === convId) newConversation();
      if (state.view === 'history') loadConversationList();
      showToast('Conversation deleted');
    })
    .catch(() => showToast('Could not delete conversation', 'error'));
}
